export enum FormFieldTypes {
    TEXT = 'text',
    DROPDOWN = 'dropdown',
    CHECKBOX = 'checkbox',
    CHECKBOX_GROUP = 'checkbox-group',
    DATEPICKER = 'datepicker',
    RADIO = 'radio',
    MULTI_DROPDOWN = 'multi-dropdown',
    AUTOCOMPLETE = 'autocomplete',
    TEXTAREA = 'textarea',
    INTERNATIONAL_PHONE = 'international-phone',
}
